import React from 'react'
import VisibleSubjects from '../subjects/containers/VisibleSubjects'
import VisibleLoggedIn from '../logged-in-home/containers/VisibleLoggedIn'
// import {withNav} from '../../../core/components/navbar/index'

const Home = ({className, isLoggedIn}) => {
  if (isLoggedIn) {
    return (
      <VisibleLoggedIn />
    )
  } else {
    return (
      <VisibleSubjects />
    )
  }

}

export default Home



// WEBPACK FOOTER //
// ./src/domains/home/components/Home.js